import React from "react";
import { PropsWithChildren } from "react";

export const TabTitle = ({ children }: PropsWithChildren<unknown>) => {
  return <p className="m-0 text-[32px]">{children}</p>;
};
